
import { Component, Vue, Prop, Model, Emit } from "vue-property-decorator";

@Component({})
export default class UserComponent extends Vue {
  name = "user";
}
